import { render, staticRenderFns } from "./ManageRound.vue?vue&type=template&id=4273374a&scoped=true&"
import script from "./ManageRound.vue?vue&type=script&lang=ts&"
export * from "./ManageRound.vue?vue&type=script&lang=ts&"
import style0 from "./ManageRound.vue?vue&type=style&index=0&id=4273374a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4273374a",
  null
  
)

export default component.exports